import type { ReceiverInput } from "@pdfking/functionpool"
import { BlobToUint8, MapAsync, ToBlob, ZipCreate } from "@pdfking/tfunc"

import { GenerateFile } from "../../files/GenerateFile"
import { RequestBlob } from "../../files/RequestBlob"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import { ContentType } from "../../types/files/ContentType"
import type { VirtualFile } from "../../types/files/VirtualFile"
import { VirtualFileType } from "../../types/files/VirtualFileType"
import type { TaskResult } from "../../types/tasks/input/TaskResult"
import type { TaskZipOptions } from "../../types/tasks/options/TaskZipOptions"
import { TaskName } from "../../types/tasks/TaskName"
import { TrackedTaskName } from "../../types/tasks/tracking/TrackedTaskName"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"

// options CompressFilesOptions
// stream GenericFile (content_id, content_type)
// emit TrackingCallback
//
// return GenericFile

export async function* TaskZip(
  engine: PdfEngine,
  _task: TaskZipOptions,
  emit: TrackingCallback,
  messages: ReceiverInput<TaskResult>
): AsyncGenerator<TaskResult> {
  const files: Record<string, VirtualFile> = {}

  async function* toZip(): Parameters<typeof ZipCreate>[0] {
    let done = 0
    const load = (done = 0) =>
      emit({
        name: TrackedTaskName.COMPRESS,
        done,
        total: undefined,
      })

    void load(done)

    for await (const { name, content } of messages) {
      const { stream } = await RequestBlob(engine, content, emit)
      yield {
        name,
        chunks: MapAsync(BlobToUint8, stream),
      }
      files[name] = content

      void load((done += 1))
    }
  }

  const content = await GenerateFile(
    engine,
    MapAsync(a => ToBlob(a), ZipCreate(toZip())),
    ContentType.ZIP,
    emit
  )

  yield {
    enum: TaskName.CONTENT_FILE,
    name: "merge.zip",
    content: {
      enum: VirtualFileType.ZIP_FILE,
      content,
      files,
      file_meta: {},
    },
  }
}
